/* istanbul ignore file */
import { css } from 'styled-components'

import theme from 'theme'

export const oneTrustStyles = css`
  #onetrust-pc-sdk .ot-vs-list .ot-always-active,
  #onetrust-pc-sdk .ot-cat-grp .ot-always-active {
    color: ${theme.colors.green} !important;
  }

  #onetrust-pc-sdk .ot-tgl input:checked + .ot-switch .ot-switch-nob {
    background-color: #cff2cd !important;
    border: 1px solid ${theme.colors.green} !important;
  }
  #onetrust-pc-sdk .ot-tgl input:checked + .ot-switch .ot-switch-nob:before {
    background-color: ${theme.colors.green} !important;
    border-color: ${theme.colors.green} !important;
  }

  #onetrust-pc-sdk * {
    font-family: 'Avenir Next', Helvetica, Arial, sans-serif !important;
    font-weight: normal !important;
  }

  #onetrust-consent-sdk #onetrust-pc-sdk {
    button:not(#clear-filters-handler):not(.ot-close-icon):not(#filter-btn-handler):not(.ot-remove-objection-handler):not(.ot-obj-leg-btn-handler):not([aria-expanded]):not(.ot-link-btn),
    .ot-leg-btn-container .ot-active-leg-btn {
      border-radius: 100px !important;
      font-weight: 600 !important;
    }
  }

  #onetrust-pc-sdk #ot-pc-title,
  #onetrust-pc-sdk #ot-category-title {
    font-weight: 600 !important;
  }

  #onetrust-pc-sdk .ot-pc-footer-logo,
  #onetrust-pc-sdk #accept-recommended-btn-handler {
    display: none !important;
  }

  #onetrust-pc-sdk .ot-cat-item:nth-of-type(1) {
    display: none !important;
  }

  #onetrust-pc-sdk #ot-pc-content {
    overflow-y: hidden !important;
  }

  .privacy-notice-link {
    margin: 0 !important;
  }

  #onetrust-pc-sdk .ot-switch-nob:before {
    background-color: ${theme.colors.green} !important;
    border-color: ${theme.colors.green} !important;
  }

  #onetrust-pc-sdk .ot-tgl input:checked + .ot-switch .ot-switch-nob:before {
    background-color: #7d7d7d !important;
  }

  #onetrust-pc-sdk .ot-switch-nob {
    background-color: #cff2cd !important;
  }

  #onetrust-pc-sdk .ot-tgl input:checked + .ot-switch .ot-switch-nob {
    background-color: #f2f1f1 !important;
    border: 1px solid #787878 !important;
  }

  #onetrust-pc-sdk .ot-switch-nob:before {
    transform: translateX(20px) !important;
    -webkit-transform: translateX(20px) !important;
  }

  #onetrust-pc-sdk .ot-tgl input:checked + .ot-switch .ot-switch-nob:before {
    transform: translateX(0px) !important;
    -webkit-transform: translateX(0px) !important;
  }

  #toogleClassOptOut {
    display: flex !important;
    align-items: center !important;
  }

  #leftNoToggleText,
  #rightNoToggleText {
    margin: 0px 5px !important;
    font-size: 12px;
  }

  #ot-category-title {
    display: none !important;
  }

  .ot-btn-container {
    @media (max-width: 767px) {
      padding: 0px 10px !important;
    }
  }
`
